// extracted by mini-css-extract-plugin
export var discard = "_1w-4";
export var muiTooltipTooltip = "_1w-6";
export var notificationBar = "_1w-3";
export var notificationContainer = "_1w-2";
export var saveButtonHoverSlotWrapper = "_1w-5";
export var show = "_1w-1";
export var spacer = "_1w-0";